// removed by extract-text-webpack-plugin
module.exports = {"footer":"index__footer___3G6lz","content":"index__content___YQgJM","contentLeft":"index__contentLeft___2ctSG","yellow":"index__yellow___3VwZ0","contentRight":"index__contentRight___2CnhI","bottom":"index__bottom___3vkHu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Footer/index.css
// module id = 708
// module chunks = 32